// Rutas públicas según el modo del tenant.
// - dominio:    el host ya identifica la institución → /{categoria}/{publicacion}
// - plataforma: el primer segmento es la institución  → /{institucion}/{categoria}/{publicacion}

// Segmentos de primer nivel que nunca son una institución.
const SEGMENTOS_RESERVADOS = new Set(['admin', 'viewer']);

// Primer segmento del pathname (sin el basename del router) o null si no hay o es reservado.
export const primerSegmento = (pathname) => {
  const segmento = (pathname || '').split('/').filter(Boolean)[0];
  if (!segmento || SEGMENTOS_RESERVADOS.has(segmento)) return null;
  try {
    return decodeURIComponent(segmento);
  } catch {
    return segmento;
  }
};

export const construirRutaPublica = (modo, slugInstitucion, path = '/') => {
  const limpio = path.startsWith('/') ? path : `/${path}`;
  if (modo !== 'plataforma' || !slugInstitucion) return limpio;
  return limpio === '/' ? `/${slugInstitucion}` : `/${slugInstitucion}${limpio}`;
};
